"use strict";
exports.__esModule = true;
exports.crossPath = void 0;
exports.crossPath = "polygon(\n    20% 0%,\n    0% 20%,\n    30% 50%,\n    0% 80%,\n    20% 100%,\n    50% 70%,\n    80% 100%,\n    100% 80%,\n    70% 50%,\n    100% 20%,\n    80% 0%,\n    50% 30%\n    );\n";
